import { graphql } from "@/shared/gql";
import { useSuspenseQuery } from "@apollo/client";
import { ContentType, ColumnsQueryVariables } from "@/shared/gql/graphql";
import { getPreloadQuery } from "@/shared/gql/apollo-client";

const Columns = graphql(`
  query Columns($contentType: ContentType!) {
    columns(contentType: $contentType) {
      id
      ...OwnColumnProps
    }
  }
`);

type Props = {
  contentType: ContentType;
};

export const useFetchColumnsQuery = ({ contentType }: Props) => {
  const result = useSuspenseQuery(Columns, {
    variables: { contentType },
  });

  if (!result.data) throw new Error("No data");

  return result.data.columns;
};

export const preloadColumnsQuery = (vars: ColumnsQueryVariables) => {
  getPreloadQuery()(Columns, {
    variables: vars,
  });
};
